<script>
  import { onMount } from 'svelte';
  import { fly } from 'svelte/transition';
  import jQuery from 'jquery';
  import { asgenerator } from '../Utils/generator.js';
  import { asnavigate } from '../Utils/asnavigation.js';
  import { useNavigate } from 'svelte-navigator';
  const navigate = useNavigate();
  import BtnInfo from '../BtnInfo/BtnInfo.svelte';
  // export let step;

  import { coordonneesNegociant } from '../stores.js';

  // onMount(async function () {
  //   try {
  //     jQuery.get(
  //       'http://localhost:8073/_SeminTrappesAjax/negociantInfo.php',
  //       // 'ajax/negociantInfo.php',
  //       function (data) {
  //         console.log('GET');
  //         console.log(data);
  //         console.log('ENDGET');
  //         // $('body')
  //         //   .append('Name: ' + data.name) // John
  //         //   .append('Time: ' + data.time); //  2pm
  //       }
  //     );
  //   } catch (error) {
  //     // erroMessage.textContent = "Une erreur c'est produite";
  //     // throw new Error("Une erreur c'est produite");
  //   }
  // });

  // console.log($coordonneesNegociant);

  let messageErreur = '';
  let promiseNegociant;

  // Si deja negociant enregistrer on va au recap
  //asnavigate(navigate, '/process/negociant/recapitulatif');

  // async function getNegociant() {
  // try {
  //   const postCode = document.querySelector('[name="as-post-code"]').value;
  //   console.log(JSON.stringify(postCode));
  //   const response = await fetch(
  //     // 'http://localhost:5000/temp/negociant.json',
  //     // 'http://localhost:8073/_SeminTrappesAjax/negociant.php',
  //     // 'https://comptoirtrappe.fr/ajax/negociant.php',
  //     '/ajax/negociant.php?getparam=ok',
  //     // 'https://httpbin.org/post',
  //     {
  //       method: 'POST',
  //       // headers: {
  //       //   Accept: 'application/json',
  //       //   'Content-Type': 'application/json',
  //       // },
  //       body: JSON.stringify({
  //         postCode: postCode,
  //       }),
  //       // credentials: 'include',
  //     }
  //   );
  //   if (response.status >= 200 && response.status <= 299) {
  //     const jsonResponse = await response.json();
  //     console.log(jsonResponse);
  //     if (jsonResponse.result) {
  //       // $coordonneesNegociant['asId'] = jsonResponse.negociantId;
  //       // $coordonneesNegociant['asCode'] = jsonResponse.code;
  //       // $coordonneesNegociant['asNomSoc'] = jsonResponse.nom;
  //       // $coordonneesNegociant['asNom'] = 'Durant';
  //       // $coordonneesNegociant['asPrenom'] = 'Marc';
  //       // $coordonneesNegociant['asEmail'] = 'marc.durant@gmail.com';
  //       // $coordonneesNegociant['asTel'] = '06 14 14 14 14';
  //       // $coordonneesNegociant['asAdresse'] = jsonResponse.adresse;
  //       // $coordonneesNegociant['asCp'] = jsonResponse.cp;
  //       // $coordonneesNegociant['asVille'] = jsonResponse.ville;
  //       // $coordonneesNegociant['asReference'] = 'référence pour client';
  //       $coordonneesNegociant['asId'] = jsonResponse.asId;
  //       $coordonneesNegociant['asCode'] = jsonResponse.asCode;
  //       $coordonneesNegociant['asNomSoc'] = jsonResponse.asNomSoc;
  //       $coordonneesNegociant['asNom'] = jsonResponse.asNom;
  //       $coordonneesNegociant['asPrenom'] = jsonResponse.asPrenom;
  //       $coordonneesNegociant['asEmail'] = jsonResponse.asEmail;
  //       $coordonneesNegociant['asTel'] = jsonResponse.asTel;
  //       $coordonneesNegociant['asAdresse'] = jsonResponse.asAdresse;
  //       $coordonneesNegociant['asCp'] = jsonResponse.asCp;
  //       $coordonneesNegociant['asVille'] = jsonResponse.asVille;
  //       $coordonneesNegociant['asReference'] = 'référence pour client';

  //       // console.log($coordonneesNegociant);

  //       // asnavigate(navigate, '/process/negociant/recapitulatif');
  //     } else {
  //       throw new Error('Le code est faux');
  //     }
  //   } else {
  //     throw new Error("Une erreur c'est produite");
  //   }
  // } catch (error) {
  //   throw new Error("Une erreur c'est produite");
  // }
  // }

  async function getNegociant() {
    try {
      const erroMessage = document.querySelector('#errorMessage');
      const postCode = document.querySelector('[name="as-post-code"]').value;
      const r = Math.random().toString(36).substring(2, 42);
      erroMessage.textContent = '';
      jQuery
        .post(
          //  'http://localhost:8073/_SeminTrappesAjax/negociantSearch.php',
          'ajax/negociantSearch.php?r=' + asgenerator(40),
          {
            postCode: postCode,
          },
          function (data, status) {
            // console.log(data);
            if (data.valid) {
              $coordonneesNegociant['id'] = data['id'];
              $coordonneesNegociant['asId'] = data['asId'];
              $coordonneesNegociant['asNomSoc'] = data['asNomSoc'];
              $coordonneesNegociant['asAdresseSoc'] = data['asAdresseSoc'];
              $coordonneesNegociant['asCpSoc'] = data['asCpSoc'];
              $coordonneesNegociant['asVilleSoc'] = data['asVilleSoc'];
              $coordonneesNegociant['asReferenceSoc'] = data['asReferenceSoc'];

              if(data['n_nom']) {
                $coordonneesNegociant['n_nom'] = data['n_nom'];
                $coordonneesNegociant['n_prenom'] = data['n_prenom'];
                $coordonneesNegociant['n_email'] = data['n_email'];
              }

              asnavigate(navigate, '/process/negociant/recapitulatif');
            }
            erroMessage.textContent = 'Identifiant inconnu';
            // throw new Error('Le code est faux');
          }
        )
        .fail(function () {
          erroMessage.textContent = "Une erreur c'est produite";
        });
    } catch (error) {
      erroMessage.textContent = "Une erreur c'est produite";
      // throw new Error("Une erreur c'est produite");
    }
  }

  function validForm() {
    //as-post-email as-post-tel qs-post-adresse as-post-cp
    const postCode = document.querySelector('[name="as-post-code"]').value;
    // console.log(postCode);

    if (document.querySelector('[name="as-post-code"]').value.length === 0) {
      document.querySelector('#errorMessage').textContent =
        "L'identifiant ne peut pas être vide";
      return;
    }
    promiseNegociant = getNegociant();
    // asnavigate(navigate, '/process/negociant/recapitulatif');
  }
</script>

<div class="as-container-neu">

  <BtnInfo /> 

  <div
    in:fly="{{ delay: 100, x: 100, duration: 800 }}"
    class="text-center mb-12"
  >
    Le code négociant est un identifiant fourni par notre équipe
  </div>

  <!-- {#await promiseNegociant}
    .
  {:catch error}
    <div
      in:fly="{{ delay: 100, x: 100, duration: 800 }}"
      class="text-center mb-12 error"
    >
      {error.message}
    </div>
  {/await}
  <div
    in:fly="{{ delay: 400, x: 100, duration: 800 }}"
    class="text-center mb-12 error"
  >
    {messageErreur}
  </div> -->

  <div id="errorMessage" class="text-center mb-12 error"></div>

  <div class="grid grid-cols-2 ">
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <div class="as-label-neu">Code négociant*</div>
      <input
        name="as-post-code"
        value=""
        type="text"
        class="as-input-neu"
        placeholder="Code négociant"
      />
    </div>

    <div in:fly="{{ delay: 300, x: 100, duration: 800 }}">
      <div class="as-btn-rounded" on:click="{() => validForm()}">Continuer</div>
    </div>
  </div>
</div>

<style>
  .error {
    /* font-family: 'introlight'; */
    color: red;
  }
  .as-btn-rounded {
    margin-top: 33px;
  }
  @media only screen and (max-width: 768px) {
    #errorMessage.text-center,
    .as-container-neu .text-center {
      text-align: left;
    }
    .as-container-neu {
      padding: 50px 40px 30px;
    }
    .grid-cols-2 {
      display: block;
    }
    .grid-cols-2 > div {
      margin-bottom: 40px;
    }
    .as-btn-rounded {
      margin-top: 5px;
      margin-bottom: 20px;
    }
  }
</style>
